import { datadogRum } from "@datadog/browser-rum";
import { ErrorBoundary as BaseErrorBoundary } from "react-error-boundary";

import { datadogFingerprint, ErrorWithFingerprint } from "./ErrorWithFingerprint";

import type { ErrorBoundaryProps } from "react-error-boundary";

export const ErrorBoundary = (props: ErrorBoundaryProps) => (
  <BaseErrorBoundary
    onError={(error, info) => {
      const ddFingerprint = datadogFingerprint(error.message);

      let renderingError;
      if (ddFingerprint) {
        renderingError = new ErrorWithFingerprint(error.message);
        renderingError.dd_fingerprint = ddFingerprint;
      } else {
        renderingError = new Error(error.message);
      }

      renderingError.name = "UnhandledReactRenderingError";
      renderingError.stack = info.componentStack ?? undefined;
      renderingError.cause = error;

      datadogRum.addError(renderingError, {
        skydioErrorHandling: "unhandled",
      });
    }}
    {...props}
  />
);
